export const ErrorType = Object.freeze({
  genericSecurityError: "AUTHK00",
  sessionExpired: "INTS401",
  softLocked: "MFA5701",
  userLocked: "MFA401",
  badTransactionState: "MFA400",
  systemError:"INTS500",
  wrongParams: "EXTCS1005",
});

export const ErrorTypeOtp = Object.freeze({
  genericSecurityError: "AUTHK00",
  systemError: "INTS500",
  invalidSession: "INTS401",
  genericErrorMS: "EXTMXXX",
  serviceError: "EXTCXXX",
  unexpectedRuntimeError: "EXTCE100X",
  flowError: "EXTCS100X",
  mfa5707: "EXTCS1004",
  invalidOtp: "EXTCS1005",
  mfa5701: "EXTCS1006",
  otpAfterSoftLock: "EXTCS1007",
  genericError: "EXTC500",
  passwordComplexitySetPass: "EXTM150",
  passwordHistorySetPass: "EXTM151",
  genericLdapErrorSetPass: "EXTM152",
  passwordComplexityResetPass: "EXTM120",
  passwordHistoryResetPass: "EXTM121",
  genericLdapErrorResetPass: "EXTM122",
  standardError: "INT0XXX",
  generalError: "INTG000",
  otpLastAttemptSoftLock: "MFA5708",
});

export const ErrorTypeResetPsw = Object.freeze({
  noAuthMethod: "EXTCS1009",
  appNotEnrolled: "EXTCS1010",
  appNotEnrolledScaGeneration: "EXTCS1017"
});
